import folder from "../common/folder";

function getNestedFolders (start: string, allFolders: folder[]) {
    let folders: folder[] = [];
    function loopThrough (folder_uid: string) {
      const filtered = allFolders.filter(e => e.parent_folder === folder_uid);
      folders = folders.concat(filtered);
      if(filtered.length === 0) {
      } else {
        filtered.forEach(e => loopThrough(e.folder_uid));
      }
    }
    loopThrough(start);
    return folders;
}

export { getNestedFolders };